<template>
  <div class="bi">
    <div class="bi__subheader width-responsiveness">
      <h2>Meus Indicadores</h2>
      <div class="bi__updated">
        <md-icon>query_builder</md-icon>
        <span>Atualizado em {{ updatedDateFormatted }}</span>
      </div>
    </div>

    <BIFilter
      :tabs="tabs"
      :active-tab-index="activeTabIndex"
      @exportar="exportReport"
      @tab-change="activeTabIndex = $event"
      @period-change="biPeriod = $event"
    />

    <div class="width-responsiveness mt-3">
      <FinancialAnalysis
        v-if="activeTabIndex === indexFinancialAnalysis"
        :period="biPeriod"
        @updated-at="updatedDate = $event"
      />
      <DeliveryPerformance
        v-if="activeTabIndex === indexDeliveryPerformance"
        :period="biPeriod"
        @updated-at="updatedDate = $event"
      />
      <RecollectionManagement
        v-if="activeTabIndex === indexRecollectionManagement"
        :period="biPeriod"
        @updated-at="updatedDate = $event"
      />
      <DemographicProfile
        v-if="activeTabIndex === indexDemographicProfile"
        :period="biPeriod"
        @updated-at="updatedDate = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import FinancialAnalysis from './tabs/FinancialAnalysis.vue'
import DeliveryPerformance from './tabs/DeliveryPerformance.vue'
import RecollectionManagement from './tabs/RecollectionManagement.vue'
import DemographicProfile from './tabs/DemographicProfile.vue'
import BIFilter from './BIFilter.vue'

const TABS = [
  { title: 'Análise Financeira' },
  { title: 'Performance de Entrega' },
  { title: 'Gestão de Recoletas' },
  { title: 'Perfil Demográfico' },
]

const INDEX_RECOLLECTION_MANAGEMENT = 2

export default {
  name: 'BIMainView',
  components: {
    BIFilter,
    FinancialAnalysis,
    DeliveryPerformance,
    RecollectionManagement,
    DemographicProfile,
  },
  data() {
    return {
      tabs: TABS,
      activeTabIndex: 0,
      indexFinancialAnalysis: 0,
      indexDeliveryPerformance: 1,
      indexRecollectionManagement: INDEX_RECOLLECTION_MANAGEMENT,
      indexDemographicProfile: 3,
      updatedDate: null,
      biPeriod: moment().format('YYYY-MM'),
    }
  },
  computed: {
    updatedDateFormatted() {
      if (!this.updatedDate) return '--'
      return moment(this.updatedDate).locale('pt-br').format('D [de] MMMM [de] YYYY')
    },
  },
  methods: {
    exportReport() {},
  },
}
</script>

<style lang="scss">
.bi {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  font-family: 'Exo 2', sans-serif !important;

  &__subheader {
    display: flex;
    justify-content: space-between;
    align-content: center;
    z-index: 1;

    h2 {
      font-size: 22px;
      font-weight: 600;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 30px;
    }
  }

  &__updated {
    display: flex;
    align-items: center;
    font-weight: 500;
    color: #7a7a7a;
    cursor: default;

    .md-icon {
      margin: 0;
      margin-right: 4px;
      width: 28px;
      height: 28px;
    }
  }
}
</style>
